<template>
  <svg  :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="11" y="4" width="2" height="16" rx="1"/>
    <line x1="4" y1="4" x2="4" y2="20"/>
    <line x1="20" y1="4" x2="20" y2="20"/>
  </svg>
</template>

<script>
export default {
  name: 'SpacingLarge',
  props: {
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    }
  }
}
</script>
